export const SOURCE_ID = 'evac_zones_ca';

export const EVAC_ZONES_EDIT_FILL_LAYER_ID = 'zones-edit-fill';
export const EVAC_ZONES_EDIT_STROKE_LAYER_ID = 'zones-edit-stroke';
export const EVAC_ZONES_EDIT_LABEL_LAYER_ID = 'zones-edit-label';
export const EVAC_ZONES_EDIT_PATTERN_LAYER_ID_PREFIX = 'zones-edit-pattern';

export const VIEW_SOURCE_ID = `${SOURCE_ID}_VIEW`;

// always show with minzoom at 1
export const ACTIVE_ZONES_LAYER_MIN_ZOOM = 1;
export const INACTIVE_ZONES_LAYER_MIN_ZOOM = 9;
export const LABEL_LAYER_MIN_ZOOM = 9;

export const EVAC_ZONES_VIEW_FILL_LAYER_ID = 'zones-view-fill';
export const EVAC_ZONES_VIEW_STROKE_LAYER_ID = 'zones-view-stroke';
export const EVAC_ZONES_VIEW_LABEL_LAYER_ID = 'zones-view-label';
export const EVAC_ZONES_VIEW_PATTERN_LAYER_ID = 'zones-view-pattern';

export const ZONES_SOURCE_LAYER = 'evaczones';
export const LABELS_SOURCE_LAYER = 'evaczone_labels';

export const FEATURE_UID_V2_FIELD_NAME = 'uid_v2';

export const EVAC_ZONES_SOURCE_LAYER_NAME = 'evaczones,evaczone_labels';
